import { Vue } from 'vue-property-decorator';
import loader from '../../utils/loader';
import store from '../../store';
import couponService from '../../services/coupon';
import tableMixin from '../../Mixins/table';
import formMixin from '../../Mixins/form';
import countryMixin from '../../Mixins/country';
import Form from '../../form/form';
import { debounce } from 'lodash';

export default Vue.extend({
  store,
  mixins: [tableMixin, formMixin, countryMixin],
  data: () => ({
    couponDetail: null,
    loadingCoupon: false,
    formCoupon: new Form({
      data() {
        return {
          id: '',
        };
      },
    }),
    countrySelected: null,
    search: '',
    coupons: [],
    totalCoupons: 0,
    couponsPagination: {},
    couponHeaders: [
      {
        text: 'Code',
        align: 'center',
        value: 'code',
        sortable: false,
      },
      {
        text: 'Description',
        align: 'center',
        value: 'description',
        sortable: false,
      },
      {
        text: 'Type',
        align: 'center',
        value: 'type',
        sortable: false,
      },
      {
        text: 'Created At',
        align: 'center',
        value: 'created_at',
        sortable: false,
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: false,
      },
      {
        text: 'Total Usage',
        align: 'center',
        value: 'total_usage',
        sortable: false,
      },
      {
        text: 'Action',
        align: 'center',
        value: 'action',
        sortable: false,
      },
    ],
    statusFilterOptions: [
      {
        text: 'All',
        value: null,
      },
      {
        text: 'Active',
        value: 'active',
      },
      {
        text: 'Expired',
        value: 'expired',
      },
    ],
    statusFilter: null,
    searchFilter: '',
  }),
  computed: {},
  watch: {
    couponsPagination: {
      handler() {
        this.getCouponList().then((data) => {
          this.coupons = data.items;
          this.totalCoupons = data.total;
        });
      },
      deep: true,
    },
    search() {
      this.getCouponList().then((data) => {
        this.coupons = data.items;
        this.totalCoupons = data.total;
      });
    },
    countrySelected() {
      this.getCouponList().then((data) => {
        this.coupons = data.items;
        this.totalCoupons = data.total;
      });
    },
  },
  created() {},
  mounted() {},
  methods: {
    refresh() {
      this.getCouponList().then((data) => {
        this.coupons = data.items;
        this.totalCoupons = data.total;
      });
    },
    getCouponList() {
      this.loadingCoupon = true;
      return new Promise((resolve, reject) => {
        const { page, itemsPerPage } = this.couponsPagination;

        let query = {};
        if (itemsPerPage !== -1) {
          query.perPage = itemsPerPage;
          query.page = page;
        }

        if (this.statusFilter !== null) {
          query.status = this.statusFilter;
        }

        if (this.searchFilter !== '') {
          query.q = this.searchFilter;
        }

        query.order = 'desc';
        query.order_by = 'created_at';
        if (this.countrySelected) query.country = this.countrySelected;

        if (this.search) query.search = this.search;

        couponService
          .getAll(query)
          .then((resultList) => {
            let items = resultList.data;
            const total = resultList.totalCount;
            this.loadingCoupon = false;
            resolve({
              items,
              total,
            });
          })
          .catch((err) => {
            this.loadingCoupon = false;
            reject(err);
          });
      });
    },
    deleteCoupon(coupon) {
      this.$root
        .$confirm('Delete', `Are you sure for deleting <b>${coupon.code}</b> ?`, {
          color: 'error',
        })
        .then((confirm) => {
          if (confirm) {
            this.formCoupon.id = coupon.id;
            couponService.deletes(coupon.id).then(() => {
              this.coupons = window._.reject(this.coupons, { id: coupon.id });
              this.totalCoupons -= 1;
              this.$notify({
                title: 'Delete',
                text: `Delete ${coupon.code} success !!`,
                type: 'success',
              });
            });
          }
        });
    },
    openCouponDetail(coupon) {
      this.couponDetail = coupon;
    },
    closeCouponDetail() {
      this.couponDetail = null;
    },
    debounceInput: debounce(function (e) {
      this.search = e;
    }, 500),
    searchFilterUpdate: debounce(function () {
      this.refresh();
    }, 500),
    statusFilterUpdate() {
      this.refresh();
    },
  },
  components: {
    CreateCoupon: loader.component('CreateCoupon'),
    CouponDetail: loader.component('CouponDetail'),
  },
});
